
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/instore",
      function () {
        return require("private-next-pages/[slug]/instore.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/instore"])
      });
    }
  